import * as Tabs from '@wandb/weave/components/Tabs';
import React, {useState} from 'react';

import {DrawerContentType} from '../../WorkspaceDrawerContextProvider';
import {SettingsContentWrapper} from '../components/SettingsContentWrapper';
import {WORKSPACE_LINE_PLOT_SETTINGS_DESCRIPTION} from '../constants';
import {LinePlotDataTab} from './LinePlotDataTab';
import {LinePlotDisplayPreferencesTab} from './LinePlotDisplayPreferencesTab';

const DEFAULT_LINE_PLOT_TAB = 'data';

export const LinePlotSettings = ({
  contentHeader,
  displayedContentType,
}: {
  contentHeader?: React.ReactNode;
  displayedContentType: DrawerContentType;
}) => {
  const [selectedTab, setSelectedTab] = useState(DEFAULT_LINE_PLOT_TAB);

  return (
    <SettingsContentWrapper
      title="Line plots"
      description={WORKSPACE_LINE_PLOT_SETTINGS_DESCRIPTION}
      header={contentHeader}>
      <Tabs.Root
        className="mt-16"
        value={selectedTab}
        onValueChange={value => setSelectedTab(value)}>
        <Tabs.List>
          <Tabs.Trigger value="data">Data</Tabs.Trigger>
          <Tabs.Trigger value="display">Display preferences</Tabs.Trigger>
        </Tabs.List>
        <Tabs.Content value="data">
          <LinePlotDataTab />
        </Tabs.Content>
        <Tabs.Content value="display">
          <LinePlotDisplayPreferencesTab
            displayedContentType={displayedContentType}
          />
        </Tabs.Content>
      </Tabs.Root>
    </SettingsContentWrapper>
  );
};
